/**
 * 404 页面未找到组件
 *
 * 当用户访问的路由无法匹配到任何已注册的页面时，由路由器渲染此组件。
 * 继承自 BaseElement，展示醒目的 404 错误信息和返回首页的链接。
 *
 * 导出内容：
 * - `NotFoundPage`（自定义元素 `crm-not-found-page`）
 *
 * 关键设计：
 * - 使用 Tailwind 工具类实现全屏居中布局
 * - 无任何业务逻辑，纯静态展示
 */
import { css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { BaseElement } from '../base-element.js';

@customElement('crm-not-found-page')
export class NotFoundPage extends BaseElement {
  /** 空样式表（完全依赖 Tailwind 工具类） */
  static styles = css``;

  /**
   * 渲染 404 页面内容
   *
   * @returns Lit 模板，包含：
   *   - 带禁止图标的圆形图标
   *   - "404" 大号标题
   *   - "页面未找到" 描述文本
   *   - 返回首页（/crm/customers）的按钮链接
   *   - URL 检查提示
   */
  render() {
    return html`
      <div class="flex flex-col items-center justify-center min-h-screen bg-bg">
        <div class="text-center">
          <div class="w-20 h-20 mx-auto mb-6 bg-primary/10 rounded-full flex items-center justify-center">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-10 h-10 text-primary"><circle cx="12" cy="12" r="10"/><path d="m15 9-6 6"/><path d="m9 9 6 6"/></svg>
          </div>
          <h1 class="m-0 font-semibold text-6xl text-text">404</h1>
          <p class="text-text-secondary text-lg mt-4">页面未找到</p>
          <a href="/crm/customers" class="inline-block mt-6 bg-primary hover:bg-primary-hover text-white px-6 py-3 rounded-md text-sm font-medium transition-colors no-underline cursor-pointer shadow-sm shadow-primary/20">返回首页</a>
          <p class="text-text-muted mt-3 text-sm">或检查 URL 是否正确</p>
        </div>
      </div>
    `;
  }
}
